import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import GameIntro from './components/GameIntro';
import CategoryHighlights from './components/CategoryHighlights';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="踩蘑菇——经典小游戏玩法全攻略 | 踩蘑菇游戏攻略大全"
        description="踩蘑菇是深受玩家喜爱的经典互动游戏，本网站详细介绍踩蘑菇的玩法规则、操作技巧、关卡攻略及高分策略，帮助新手快速上手、老玩家突破极限，立即体验踩蘑菇的无穷乐趣！"
        keywords="踩蘑菇,踩蘑菇游戏攻略,踩蘑菇玩法技巧,踩蘑菇关卡通关,踩蘑菇高分秘籍,经典踩蘑菇在线玩,踩蘑菇新手教程"
        canonicalUrl="https://jlsdfdl.cn/"
      />
      <SchemaOrg type="WebSite" data={{
        name: '踩蘑菇攻略大全',
        url: 'https://jlsdfdl.cn/',
        description: '最全面的踩蘑菇游戏攻略网站，提供玩法技巧、关卡攻略、高分秘籍和隐藏要素等丰富内容。',
        inLanguage: 'zh-CN',
      }} />
      <SchemaOrg type="Organization" data={{
        name: '踩蘑菇攻略团队',
        url: 'https://jlsdfdl.cn/',
        description: '专注踩蘑菇游戏攻略的创作与分享团队',
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          { '@type': 'Question', name: '踩蘑菇游戏是免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的！踩蘑菇经典版完全免费。重制版基础关卡也免费开放，额外的三个扩展关卡可以通过一次性购买解锁。' } },
          { '@type': 'Question', name: '踩蘑菇支持哪些平台？', acceptedAnswer: { '@type': 'Answer', text: '踩蘑菇目前支持Windows、Mac、iOS和Android平台。' } },
          { '@type': 'Question', name: '怎么才能获得高分？', acceptedAnswer: { '@type': 'Answer', text: '获得高分的关键在于连击系统和时间奖励。连续踩踏蘑菇不落地可以获得分数加成。' } },
          { '@type': 'Question', name: '反弹跳怎么操作？', acceptedAnswer: { '@type': 'Answer', text: '当你踩中蘑菇的瞬间（约0.1秒窗口期），再次按下跳跃键，角色会以1.5倍高度弹起。' } },
          { '@type': 'Question', name: '隐藏关卡怎么进入？', acceptedAnswer: { '@type': 'Answer', text: '游戏中目前有三个隐藏关卡：倒置世界、像素怀旧关、蘑菇王国。' } },
        ],
      }} />
      <Navbar />
      <main>
        <HeroSection />
        <GameIntro />
        <CategoryHighlights />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}